const forge = require("node-forge")

const randomElement = (arr = []) => {
  return arr[Math.floor(Math.random() * arr.length)]
}

const kebab = (str) => {
  return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
}

const toggleFullScreen = () => {
  let doc = window.document
  let docEl = doc.documentElement

  let requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen
  let cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen

  if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
    requestFullScreen.call(docEl)
  } else {
    cancelFullScreen.call(doc)
  }
}

const encryptPayloadHandler = (data) => {
  const plaintext = JSON.stringify(data);
  const salt = forge.random.getBytesSync(16);
  const iv = forge.random.getBytesSync(16);
  const ENCRYPTION_KEY = process.env.VUE_APP_ENCRYPTION_KEY;
  const keySize = 32; // AES-256 requires a 32-byte key
  const iterations = 5000; // More iterations = more secure, but slower key derivation

  const derivedKey = forge.pkcs5.pbkdf2(
    ENCRYPTION_KEY,
    salt,
    iterations,
    keySize,
    "sha256"
  );
  const cipher = forge.cipher.createCipher("AES-CBC", derivedKey);
  cipher.start({
    iv: iv,
  });
  cipher.update(forge.util.createBuffer(plaintext, "utf8"));
  cipher.finish();

  const encrypted = cipher.output;
  const encryptedBase64 = forge.util.encode64(encrypted.data);

  return {
    encryptedData: encryptedBase64,
    key1: forge.util.encode64(salt),
    key2: forge.util.encode64(iv),
  };
}

const checkPasswordStrength = (password) => {
  let score = 0;
  if (!password) {
    return { score: 0, message: "No password provided" };
  }
  if (password.length < 8) {
    return { score: 0, message: "Password is too short" };
  }
  if (password.length >= 8) {
    score++;
  }
  if (password.match(/\d+/)) {
    score++;
  }
  if (password.match(/[a-z]/) && password.match(/[A-Z]/)) {
    score++;
  }
  if (password.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,)]/)) {
    score++;
  }

  switch (score) {
    case 0:
    case 1:
      return { score, color: "red", message: "Weak" };
    case 2:
      return { score, color: "orange", message: "Moderate" };
    case 3:
      return { score, color: "yellow", message: "Strong" };
    case 4:
      return { score, color: "light-green", message: "Very Strong" };
    default:
      return { score, color: "green", message: "Very Strong" };
  }
}

export default {
  randomElement,
  toggleFullScreen,
  kebab,
  encryptPayloadHandler,
  checkPasswordStrength
}
